import { Button, Modal, Row, Col } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { EntityState } from "../../models/EntityState";
import { NumberInputField } from '../bootstrap/NumberInputField';
import { TextInputField } from '../bootstrap/TextInputField';

export function EaCessationModal({
  show,
  setShow,
  entityDetails,
  submit,
}) {

    return (
        <Modal show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <FormattedMessage id={'eaAccreditation.cessation.cessate'} />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <TextInputField
                        disabled
                        labelId={'eaAccreditationForm.step1.description'}
                        value={entityDetails.description}
                    />
                </Row>
                <Row>
                    <NumberInputField
                        disabled
                        labelId={'eaAccreditationForm.step1.nif'}
                        value={entityDetails.nif}
                    />
                </Row>
            </Modal.Body>
            <Modal.Footer className='justify-content-between'>
                <Button variant="outline-secondary" onClick={() => setShow(false)}>
                    <FormattedMessage id="all.cancel" />
                </Button>
                <Button variant="outline-primary" onClick={() => submit()}>
                    <FormattedMessage id={'eaAccreditation.cessation.cessate.button'} />
                </Button>
            </Modal.Footer>
        </Modal>
    )
}